import { useState, useEffect } from "react";
import { Tabs, Tab, styled } from "@mui/material";
import HeaderComponent from "@components/common/Header/Header";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import UserManagementOnboardedUser from "./UserManagementOnboardedUser";
import UserManagementEditProfileRequest from "./UserManagementEditProfileRequest";

// Styled components for tabs
const StyledTabs = styled(Tabs)({
  minHeight: "unset",
  "& .MuiTabs-indicator": {
    display: "none",
  },
});

const StyledTab = styled(Tab)({
  minHeight: "unset",
  padding: "8px 16px",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 600,
  minWidth: "unset",
});

const StaffManagement = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Set default tab content on mount
  useEffect(() => {
    setActiveTab(0);
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <div className="tw-relative">
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-pt-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                User Management
              </h1>
            </div>
          </div>
          <div className="tw-w-fit tw-mt-4 tw-border tw-border-[#E9EAEB]">
            <StyledTabs value={activeTab} onChange={handleTabChange}>
              <StyledTab
                label="Onboarded User"
                className={`tw-text-sm tw-font-semibold ${
                  activeTab === 0 ? "active-tab" : "tw-text-[#232323]"
                } tab-border`}
              />
              <StyledTab
                label="Invited User"
                className={`tw-text-sm tw-font-semibold ${
                  activeTab === 1 ? "active-tab" : "tw-text-[#232323]"
                } tab-border`}
              />
              <StyledTab
                label="Edit Profile Request"
                className={`tw-text-sm tw-font-semibold ${
                  activeTab === 2 ? "active-tab" : "tw-text-[#232323]"
                } tab-border`}
              />
            </StyledTabs>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="tw-mt-[177px]">
        {activeTab === 0 || activeTab === 1 ? (
          <UserManagementOnboardedUser onClose={() => {}} onSubmit={() => {}} />
        ) : (
          <UserManagementEditProfileRequest
            onClose={() => {}}
            onSubmit={() => {}}
          />
        )}
      </div>
    </div>
  );
};

export default StaffManagement;
